class PdpAddon extends HTMLElement {
  connectedCallback() {
    this.priceElement = this.querySelector('[data-addon-price]');
    this.variantField = this.querySelector('[data-addon-variant]');
    this.toggle = this.querySelector('[data-addon-toggle]');

    this.variantField?.addEventListener('change', this.#updatePrice);
  }

  disconnectedCallback() {
    this.variantField?.removeEventListener('change', this.#updatePrice);
  }

  get selected() {
    return Boolean(this.toggle?.checked);
  }

  get variantId() {
    return Number(this.variantField?.value);
  }

  reset() {
    if (this.toggle) this.toggle.checked = false;
  }

  #updatePrice = () => {
    const option = this.variantField?.selectedOptions?.[0];
    if (option?.dataset.price && this.priceElement) {
      this.priceElement.textContent = option.dataset.price;
    }
  };
}

if (!customElements.get('pdp-addon')) {
  customElements.define('pdp-addon', PdpAddon);
}

// Listens on window (capture) so it runs before the theme's own submit handler:
// adds the add-on first, then re-submits the form so the cart shows both items.
window.addEventListener(
  'submit',
  async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.action || !form.action.includes('/cart/add')) return;
    if (form.dataset.addonPassed === 'true') return;

    const addon = form.closest('.shopify-section')?.querySelector('pdp-addon');
    if (!addon || !addon.selected || !addon.variantId) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: addon.variantId, quantity: 1 }] }),
      });
      if (!response.ok) throw new Error('Add-on could not be added');
    } catch (error) {
      console.error(error);
    }

    addon.reset();
    form.dataset.addonPassed = 'true';
    form.requestSubmit(event.submitter ?? undefined);
    setTimeout(() => delete form.dataset.addonPassed, 0);
  },
  true
);
